import React from "react";
import { Header, Hero, Feature, Pricing, Footer } from "./Components";

export function Home() {
  return (
    <>
      <Header />
      <Hero />
      <Feature />
      <Pricing />
      <Footer />
    </>
  );
}
